/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CarpsaleManagementCategoryItemRequest } from '../models/CarpsaleManagementCategoryItemRequest';
import type { CarpsaleManagementCategoryItemResponseApiRespoonse } from '../models/CarpsaleManagementCategoryItemResponseApiRespoonse';
import type { CarpsaleManagementCreateItemRequest } from '../models/CarpsaleManagementCreateItemRequest';
import type { CarpsaleManagementCreateItemResponseApiRespoonse } from '../models/CarpsaleManagementCreateItemResponseApiRespoonse';
import type { CarpsaleManagementCreateSaleRequest } from '../models/CarpsaleManagementCreateSaleRequest';
import type { CarpsaleManagementCreateSaleResponseApiRespoonse } from '../models/CarpsaleManagementCreateSaleResponseApiRespoonse';
import type { CarpsaleManagementDeleteItemRequest } from '../models/CarpsaleManagementDeleteItemRequest';
import type { CarpsaleManagementDeleteItemResponseApiRespoonse } from '../models/CarpsaleManagementDeleteItemResponseApiRespoonse';
import type { CarpsaleManagementEditItemQuantityRequest } from '../models/CarpsaleManagementEditItemQuantityRequest';
import type { CarpsaleManagementEditItemQuantityResponseApiRespoonse } from '../models/CarpsaleManagementEditItemQuantityResponseApiRespoonse';
import type { CarpsaleManagementEditItemRequest } from '../models/CarpsaleManagementEditItemRequest';
import type { CarpsaleManagementEditItemResponseApiRespoonse } from '../models/CarpsaleManagementEditItemResponseApiRespoonse';
import type { CarpsaleManagementExportItemRequest } from '../models/CarpsaleManagementExportItemRequest';
import type { CarpsaleManagementExportItemResponseApiRespoonse } from '../models/CarpsaleManagementExportItemResponseApiRespoonse';
import type { CarpsaleManagementGenerateCertRequest } from '../models/CarpsaleManagementGenerateCertRequest';
import type { CarpsaleManagementGenerateCertResponseApiRespoonse } from '../models/CarpsaleManagementGenerateCertResponseApiRespoonse';
import type { CarpsaleManagementImportItemRequest } from '../models/CarpsaleManagementImportItemRequest';
import type { CarpsaleManagementImportItemResponseApiRespoonse } from '../models/CarpsaleManagementImportItemResponseApiRespoonse';
import type { CarpsaleManagementListEditItemRequest } from '../models/CarpsaleManagementListEditItemRequest';
import type { CarpsaleManagementListEditItemResponseApiRespoonse } from '../models/CarpsaleManagementListEditItemResponseApiRespoonse';
import type { CarpsaleManagementListItemRequest } from '../models/CarpsaleManagementListItemRequest';
import type { CarpsaleManagementListItemResponseApiRespoonse } from '../models/CarpsaleManagementListItemResponseApiRespoonse';
import type { CarpsaleManagementListSaleRequest } from '../models/CarpsaleManagementListSaleRequest';
import type { CarpsaleManagementListSaleResponseApiRespoonse } from '../models/CarpsaleManagementListSaleResponseApiRespoonse';
import type { CarpsaleManagementPreviewItemRequest } from '../models/CarpsaleManagementPreviewItemRequest';
import type { CarpsaleManagementPreviewItemResponseApiRespoonse } from '../models/CarpsaleManagementPreviewItemResponseApiRespoonse';
import type { CarpsaleManagementSyncItemRequest } from '../models/CarpsaleManagementSyncItemRequest';
import type { CarpsaleManagementSyncItemResponseApiRespoonse } from '../models/CarpsaleManagementSyncItemResponseApiRespoonse';
import type { CarpsaleManagementViewItemRequest } from '../models/CarpsaleManagementViewItemRequest';
import type { CarpsaleManagementViewItemResponseApiRespoonse } from '../models/CarpsaleManagementViewItemResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CarpsaleManagementCarpsaleService {

    /**
     * 錦鯉販売商品一覧
     * @param requestBody
     * @returns CarpsaleManagementListItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsale(
        requestBody: CarpsaleManagementListItemRequest,
    ): CancelablePromise<CarpsaleManagementListItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品の新規登録
     * @param requestBody
     * @returns CarpsaleManagementCreateItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleCreate(
        requestBody: CarpsaleManagementCreateItemRequest,
    ): CancelablePromise<CarpsaleManagementCreateItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品の表示
     * @param requestBody
     * @returns CarpsaleManagementViewItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleView(
        requestBody: CarpsaleManagementViewItemRequest,
    ): CancelablePromise<CarpsaleManagementViewItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品の更新
     * @param requestBody
     * @returns CarpsaleManagementEditItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleEdit(
        requestBody: CarpsaleManagementEditItemRequest,
    ): CancelablePromise<CarpsaleManagementEditItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/carpsale/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品の在庫数の更新
     * @param requestBody
     * @returns CarpsaleManagementEditItemQuantityResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleEditQuantity(
        requestBody: CarpsaleManagementEditItemQuantityRequest,
    ): CancelablePromise<CarpsaleManagementEditItemQuantityResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/carpsale/edit-quantity',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品の削除
     * @param requestBody
     * @returns CarpsaleManagementDeleteItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleDelete(
        requestBody: CarpsaleManagementDeleteItemRequest,
    ): CancelablePromise<CarpsaleManagementDeleteItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/carpsale/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品プレビュー
     * @param requestBody
     * @returns CarpsaleManagementPreviewItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsalePreview(
        requestBody: CarpsaleManagementPreviewItemRequest,
    ): CancelablePromise<CarpsaleManagementPreviewItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/preview',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * リストの更新
     * @param requestBody
     * @returns CarpsaleManagementListEditItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleListEdit(
        requestBody: CarpsaleManagementListEditItemRequest,
    ): CancelablePromise<CarpsaleManagementListEditItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/list-edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * セール期間の新規登録
     * @param requestBody
     * @returns CarpsaleManagementCreateSaleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleSale(
        requestBody: CarpsaleManagementCreateSaleRequest,
    ): CancelablePromise<CarpsaleManagementCreateSaleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/sale',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * セール情報一覧
     * @param requestBody
     * @returns CarpsaleManagementListSaleResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleListSale(
        requestBody: CarpsaleManagementListSaleRequest,
    ): CancelablePromise<CarpsaleManagementListSaleResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/list-sale',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Export csv
     * @param requestBody
     * @returns CarpsaleManagementExportItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleExport(
        requestBody: CarpsaleManagementExportItemRequest,
    ): CancelablePromise<CarpsaleManagementExportItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/export',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Import Csv
     * @param requestBody
     * @returns CarpsaleManagementImportItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleImport(
        requestBody: CarpsaleManagementImportItemRequest,
    ): CancelablePromise<CarpsaleManagementImportItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/import',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品カテゴリ別一覧
     * @param requestBody
     * @returns CarpsaleManagementCategoryItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleListSort(
        requestBody: CarpsaleManagementCategoryItemRequest,
    ): CancelablePromise<CarpsaleManagementCategoryItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/list-sort',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売商品表示順更新
     * @param requestBody
     * @returns CarpsaleManagementSyncItemResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleSync(
        requestBody: CarpsaleManagementSyncItemRequest,
    ): CancelablePromise<CarpsaleManagementSyncItemResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/sync',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 錦鯉販売 証明書発行リクエスト
     * @param requestBody
     * @returns CarpsaleManagementGenerateCertResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCarpsaleGenerateCert(
        requestBody: CarpsaleManagementGenerateCertRequest,
    ): CancelablePromise<CarpsaleManagementGenerateCertResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/carpsale/generate-cert',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
